import React, { FC } from 'react';
import { MotifProgressBar } from '@ey-xd/motif-react';

import './ProgressBar.scss';

type ProgressBarProps = {
    isIndeterminate?: boolean;
    labelComponent?: string;
};

const ProgressBar: FC<ProgressBarProps> = ({
    isIndeterminate,
    labelComponent
}: ProgressBarProps) => (
    <MotifProgressBar
        isIndeterminate={isIndeterminate}
        labelComponent={<span className="progress-bar">{labelComponent}</span>}
    />
);

export default ProgressBar;
